import React from 'react';
import FormField from '../FormField';

export default function GovernancaPlanejamento() {
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre a situação atual da governança municipal, do planejamento e da cooperação intermunicipal.</p>
      </div>

      <div className="mt-4">
        <FormField
          name="governanca_planejamento_situacao"
          label="Situação atual"
          type="textarea"
          placeholder="Descreva a situação atual da governança municipal, considerando Plano Diretor, Plano de Mobilidade, Plano de Saneamento e participação em consórcios públicos"
          helpText="Considere Plano Diretor, Plano de Mobilidade, Plano de Saneamento e participação em consórcios públicos"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="governanca_planejamento_indicadores"
          label="Principais indicadores"
          type="textarea"
          placeholder="Informe a existência, o ano, a vigência e a situação de atualização dos planos municipais, além da quantidade e das áreas de atuação dos consórcios dos quais o município participa"
          helpText="Existência, ano, vigência e situação de atualização dos planos municipais, além da quantidade e das áreas de atuação dos consórcios"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="governanca_planejamento_problemas"
          label="Principais problemas identificados"
          type="textarea"
          placeholder="Descreva os principais problemas identificados na governança, no planejamento e na cooperação intermunicipal"
          helpText="Principais problemas identificados na governança, no planejamento e na cooperação intermunicipal"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="governanca_planejamento_demandas"
          label="Demandas prioritárias identificadas"
          type="textarea"
          placeholder="Descreva as demandas prioritárias identificadas para atualização de planos, fortalecimento institucional, cooperação, consórcios e capacidade de gestão"
          helpText="Considere atualização de planos, fortalecimento institucional, cooperação, consórcios e capacidade de gestão"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao9"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />

        <FormField
          name="links_acesso_secao9"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
